import * as React from 'react'

const SvgUnlockedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8.75H7.5V5a2.5 2.5 0 015 0h1.25a3.75 3.75 0 10-7.5 0v3.75H5c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10c0-.69-.56-1.25-1.25-1.25zm0 8.75H5V10h10v7.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgUnlockedIcon
